import { Avatar, Button, ConfigProvider, Dropdown, Menu, Modal } from "antd";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import GeneralBloc from "../../../bloc/general_bloc";
import "./app_header.css";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import { connect } from "react-redux";
import { ReactComponent as ProfileIcon } from "../../../Account.svg";
import { ReactComponent as SwitchIcon } from "../../../Switch.svg";
import AuthBloc from "../../../bloc/auth_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import { logOut, setAuth } from "../../../data/redux/reducers/authReducer";
import { ReactComponent as LogoutIcon } from "../../../Logout.svg";
import { ReactComponent as MenulistIcon } from "../../../Menulist.svg";
import { withAuth0 } from '@auth0/auth0-react';
import Cookies from 'js-cookie';

class AppHeader extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      client: Config.context,
      route: routeParams,
      userData: null,
      loading: false,
      logoutModalOpen: false
    };
  }

  stateUserData() {
    return this.state.userData;
  }
  stateEntityName() {
    return this.state.userData?.roles[0].entityName || "";
  }

  componentDidMount() {
    this.getUserData();
  }

  async getUserData(){
    let userData = await AuthBloc.getDataUser();
    this.setState({
      userData,
    });
  }

  handleLogoutModalOpen() {
    this.setState({ logoutModalOpen: true });
  }

  handleLogoutModalClose() {
    this.setState({ logoutModalOpen: false });
  }

  logoByEntity() {
    let basePath = GeneralBloc.getAssetsContextPath() + "/assets/images/Logo/";
    let hsbcEntity = "";
    let allianceEntity = "";
    let mbsbEntity = "";
    if (this.state.userData?.availBanks && this.state.userData?.availBanks.length > 0) {
    // if (this.props.userGlobal?.availBanks && this.props.userGlobal?.availBanks.length > 0) {
      this.state.userData.availBanks.forEach((element) => {
      // this.props.userGlobal.availBanks.forEach((element) => {
        if (element.id == Config.entity.hsbc.code) {
          hsbcEntity = element.name;
        }
        if (element.id == Config.entity.alliance.code) {
          allianceEntity = element.name;
        }
        if (element.id == Config.entity.mbsb.code) {
          mbsbEntity = element.name;
        }
      });
    } else {
      this.props.userGlobal?.roles.forEach((element) => {
        if (element.entity == Config.entity.hsbc.code) {
          hsbcEntity = element.entity;
        }
        if (element.entity == Config.entity.alliance.code) {
          allianceEntity = element.entity;
        }
        if (element.entity == Config.entity.mbsb.code) {
          mbsbEntity = element.entity;
        }
      });
    }
    
    if (this.state.route?.entity == hsbcEntity) {
      basePath = basePath + Config.entity.hsbc.logo;
    } else if (this.state.route?.entity == allianceEntity) {
      basePath = basePath + Config.entity.alliance.logo;
    } else if (this.state.route?.entity === mbsbEntity) {
      basePath = basePath + Config.entity.mbsb.logo;
    } else {
      if (hsbcEntity.length > 0) {
        basePath = basePath + Config.entity.hsbc.logo;
      } else if (mbsbEntity.length > 0) {
        basePath = basePath + Config.entity.mbsb.logo;
      } else {
        basePath = basePath + Config.entity.alliance.logo;
      }
    }  
    if(this.props.route=="MBSB"){
      basePath = GeneralBloc.getAssetsContextPath() + "/assets/images/Logo/" + Config.entity.mbsb.logo;
    }
    return basePath;
  }

  companyNameByEntity() {
    switch (this.props.userGlobal?.roles[0].entity) {
      case Config.entity.hsbc.code:
        return "HSBC Amanah";
      case Config.entity.alliance.code:
        return "Alliance Islamic Bank Berhad";
      case Config.entity.mbsb.code:
        return "MBSB Bank Berhad";
      default:
        return null;
    }
  }

  getInitial(name) {
    if (name) {
      let result = GeneralBloc.mergeIntoInitialName(name);
      if (result) {
        return result;
      }
      return "";
    }
    return "";
  }

  async onLogout() {     
    const { logout } = this.props.auth0;
    AuthBloc.resetAuthData();    
    const allCookies = Cookies.get(); // Get all cookies as an object
    Object.keys(allCookies).forEach((cookie) => Cookies.remove(cookie));
    logout({ returnTo: window.location.origin, federated: true})
  }

  async redirectToLogin() {
    let godMode = AuthBloc.getGodMode();
    const { logout } = this.props.auth0;
    AuthBloc.resetAuthData();
    if (godMode === true || godMode === "true") {
      window.location.href = `/${Config.context}/login-admin`;
      localStorage.removeItem("godMode");
    } else {
      this.onLogout()       
    }
  }

  async logOutPortal() {
    this.setState({
      loading: true,
    });
    AuthBloc.logOutPortal()
      .then((result) => {
        this.redirectToLogin();
      })
      .catch((e) => {
        this.redirectToLogin();
      });
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  getSelectedBank() {
    return JSON.parse(localStorage.getItem("selectedBank"));
  }

  getDropDownItemMenu() {
    let items = [];
    let selectedBank = this.getSelectedBank();
    items.push(
      {
        label: (
          <a
            href={`/${this.state.client}/${this.props.route}/${Config.routes.generic.home}`}
            className="header-title__dropdown-item"
          >
            Banca
          </a>
        ),
        key: "0",
      }
    )

        if ((this.props.userGlobal?.roles[0].entity === 'AIS' || selectedBank?.id === 'AIS') || (this.props.userGlobal?.roles[0].entity === 'MBS' || selectedBank?.id === 'MBS')) {
      items.push(
        {
          label: (
            <a
              href={`/${this.state.client}/${this.props.route}/mrtt/${Config.routes.generic.home}`}
              className="header-title__dropdown-item"
            >
              MRTT
            </a>
          ),
          key: "1"
        },
      )
    }

    return items;
  }

  getDropDownItemDependOnRole() {
    let items = [];

    items.push(
      {
        label: (
          <a
            href={`/${this.state.client}/${this.props.route}/${Config.routes.generic.profile}`}
            className="header-title__dropdown-item"
          >
            View Profile
          </a>
        ),
        key: "0",
        icon: <ProfileIcon />,
      }
    )

    if (AuthBloc.isHeadOfBanca(this.props.userGlobal?.roles[0].id)) {
      items.push(
        {
          label: (
            <a
              href={`/${this.state.client}/${Config.routes.generic.account}`}
              className="header-title__dropdown-item"
            >
              Switch Bank
            </a>
          ),
          key: "1",
          icon: <SwitchIcon style={{ marginLeft: -5 }} />,
        },
      )
    }

    items.push(
      {
        label: (
          <a
            className="header-title__dropdown-item"
            rel="noopener noreferrer"
            /* href="/portal" */
            // onClick={() => this.logOutPortal()}
            onClick={() => this.handleLogoutModalOpen()}
          >
            Logout
          </a>
        ),
        icon: <LogoutIcon style={{ marginLeft: -5 }} />,
        key: "2",
      }
    )

    return items;
  }

  render() {
    return (
      <>
        {this.state.loading && this.loadingContent()}
        <div className="header">
          <nav>
            <ul className="menu">
              <li>
                <Link
                  to={`/${this.state.client}/${this.props.route}/${Config.routes.generic.home}`}
                >
                  <img
                    className="logo_bank_icon"
                    src={
                      GeneralBloc.getAssetsContextPath() +
                      `/assets/images/Logo/FWDLogo.png`
                    }
                    alt="FWD Logo"
                  />
                </Link>
                {this.stateUserData() ? (
                  <img
                    className=""
                    src={this.logoByEntity()}
                    height={this.logoByEntity() == "/portal/assets/images/Logo/AllianceLogo.png" ? 46 :this.logoByEntity() == "/portal/assets/images/Logo/HSBCLogo.png" ? 36: 40}
                    width={this.logoByEntity() == "/portal/assets/images/Logo/AllianceLogo.png" ? 136: this.logoByEntity() == "/portal/assets/images/Logo/HSBCLogo.png" ? 126: 180}
                    style={{
                      marginLeft: 35.68,
                      fontWeight: 400,
                    }}
                  />
                ) : null}
              </li>
              {this.props.children}
              <div className="d-flex justify-content-center align-items-center">
                <li className="mx-2">
                  <Dropdown
                    overlay={
                      <Menu
                        style={{
                          marginTop: "12px",
                        }}
                        items={this.getDropDownItemMenu()}
                      />
                    }
                    trigger={["click"]}
                    className="header__profile"
                  >
                    <MenulistIcon />
                  </Dropdown>

                </li>
                <li>
                  <Dropdown
                    overlay={
                      <Menu
                        style={{
                          marginTop: "12px",
                        }}
                        items={this.getDropDownItemDependOnRole()}
                      />
                    }
                    trigger={["click"]}
                    className="header__profile"
                  >
                    <div className="user-info d-flex align-items-center justify-content-around">
                      {/* Error in IPAD here */}
                      <Avatar
                        className="d-flex justify-content-center"
                        style={{
                          color: "#EE7623",
                          backgroundColor: "#F2F2F2",
                          marginRight: 12,
                        }}
                        size={40}
                      >
                        <div
                          className="d-flex justify-content-center"
                          style={{ fontSize: 18 }}
                        >
                          {" "}
                          {this.getInitial(this.props.userGlobal?.displayName)}
                        </div>
                      </Avatar>

                      <div className="mr-3">
                        <div className="user-info__name">
                          {this.props.userGlobal?.displayName || ''}
                        </div>
                        {/* { this.props.route ? 
                          (Config.entity[this.props.route.toLowerCase()].designationTitle===true || AuthBloc.isHeadOfBanca(this.props.userGlobal.roles[0].id)) && <div className="user-info__role">
                          {this.props.userGlobal.designationTitle}
                          </div> :null
                        }                         */}
                        <div className="user-info__role">
                          {/* {this.companyNameByEntity()} */}
                          {this.props.userGlobal?.designationTitle || ''}
                        </div>
                      </div>
                      {/* Error in IPAD here */}
                      <img
                        style={{ cursor: "pointer" }}
                        src={
                          GeneralBloc.getAssetsContextPath() +
                          `/assets/icons/ArrowDownIcon.svg`
                        }
                      />

                    </div>
                  </Dropdown>
                </li>
              </div>
            </ul>
          </nav>
        </div>

        <Modal
          closable={false}
          open={this.state.logoutModalOpen}
          footer={null}
        >
          <div className="logout_text">Logout of your account?</div>
          <div className="column mt-3 d-flex justify-content-end">
            <Button
              type='text'
              style={{ color: '#EE7623', fontSize: 14, fontWeight: '500' }}
              className="logout_cancel_button "
              onClick={() => this.handleLogoutModalClose()}
            >
              Cancel
            </Button>
            <Button
              type='text'
              style={{ color: '#FFFFFF', backgroundColor: '#183028', fontSize: 14, fontWeight: '600' }}
              className="logout_ok_button "
              onClick={() => this.logOutPortal()}
            >
              Logout
            </Button>
          </div>
        </Modal>

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userGlobal: state.user.value,
});

const mapDispatchToProps = { setAuth, logOut };

export default withAuth0(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppHeader)
));
